import React from "react";
import "../styles/IndicadorAds.scss";

export default function IndicadorAds() {
  return (
    <section className="ovit-indicadorAds" aria-label="Indicador de experiencia en campañas" id="nosotrosH">
      <div className="ovit-indicadorAds__container">
        <div className="ovit-indicadorAds__card">
          <div className="ovit-indicadorAds__top">
            <div className="ovit-indicadorAds__kicker">
              <span className="ovit-indicadorAds__dot" aria-hidden="true" />
              <span>Experiencia real en publicidad</span>
            </div>

            <span className="ovit-indicadorAds__proof">
              Comprobable
            </span>
          </div>

          <h3 className="ovit-indicadorAds__title">
            <span className="ovit-indicadorAds__money">+$1,000,000 MXN</span>{" "}
            invertidos en campañas
          </h3>

          <p className="ovit-indicadorAds__subtitle">
            Administramos presupuesto real en Meta Ads. Optimizamos para ventas y retorno
            según tu giro, tu oferta y tu zona.
          </p>

          <div className="ovit-indicadorAds__badges">

            <div className="ovit-badge">
              <span className="ovit-badge__big">ROI</span>
              <span className="ovit-badge__small">enfocado a resultados</span>
            </div>

            <div className="ovit-badge">
              <span className="ovit-badge__big">ROAS</span>
              <span className="ovit-badge__small">objetivo 2x+ cuando aplica</span>
            </div>
          </div>
        </div>
      </div><br/><br/><br/>
    </section>
  );
}
